// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Notification_notifications__1KITM","notification":"Notification_notification__3miU7","appear":"Notification_appear__PNS-k"};